import FormType from "../../Components/Form/FormType";
const FormOptions = {
	Fields: [
		{
			element: FormType.Input,
			required: true,
			label: "Email",
			name: "email",
			placeholder: "Enter engineer's email",
		},
	],
	Buttons: [{ text: "Add", className: "Btn-Mid Active" }],
};
export default FormOptions;
